import React, {Component} from "react";  import config from 'react-global-configuration';
import jwt_decode from 'jwt-decode';
import axios from "axios";
import SimpleReactValidator from "simple-react-validator";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {connect}  from  "react-redux";
import ModalD from "react-awesome-modal";
import imgNobody from '../assets/img/faces/nobody_m.original.jpg';
import * as moment from "moment";
import {Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
class UserProfile extends Component {
    state = {
        editUserData: {
            id: '',
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            org: '',
            _notificationSystem: null,
            current_password:'',
            new_password:'',
            re_type_password:'',
            login_type:'',
            user_type:'',

            organizationName: '',
            designation:'',
            lastAccess:null,
            userType: '',
            is_active:'',
            last_logged_on:null,
        },
        distributorId:'',
        distributorName:'',
        distriUserType:'Warehouse',
        warehousedivDis:'none',

        newInfoModel:false,
        action_type:'User Profile',
        desigEditBox:false,
        authEditBox:false
    };
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };


    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;

        const token = localStorage.usertoken;
        let warehouse_id = '';
        if (token != null) {
            const decoded = jwt_decode(token);
            warehouse_id = decoded.warehouse_id
        }



        this.setState({
            distributorId:  warehouse_id
        })

    }

    componentWillMount() {
     this.props.currentMenu("unipaynext");
        this.validator = new SimpleReactValidator();
        const token = localStorage.usertoken;
       // console.log(token);
        const decoded = jwt_decode(token);
       // console.log(decoded);
        this.setState({
            login_type:decoded.loginType,
            user_type:decoded.userType,
            auth_type:decoded.authType,
        });

        if(decoded.userGroupName ==='Distributor')
        {
            this.setState({
                distriUserType: 'Distributor'
            });
        }


        axios.get(config.get('API_URL')+'/users/profile', {
            headers: {
                Authorization: ` ${token}`
            }
        })
            .then(response => {
              //  console.log(response);
                this.setState({
                    editUserData: {
                        id: response.data.user_id,
                        firstName: response.data.first_name,
                        lastName: response.data.last_name,
                        email: response.data.email,
                        phone: response.data.phone,
                        //org: response.data.org
                        organizationName: response.data.extra_data.organization,
                        designation:response.data.designation,
                        is_active:response.data.status,
                        //last_logged_on:null,
                    }

                });
                return response.data
            })
            .catch(err => {
                console.log(err)
            })

        //Get Distributor Name


        let warehouse_id = '';
        if (token != null) {
            const decoded = jwt_decode(token);
            warehouse_id = decoded.warehouse_id
        }

        if(decoded.userGroupName ==='Warehouse' || decoded.userGroupName ==='Distributor' ) {

this.setState({
    warehousedivDis:'block'
})

            axios.get(config.get('API_URL') + '/inventory/getDistributorName?user_id=' + warehouse_id, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`,
                    SalesforceToken: ` ${localStorage.salesforce_token}`
                }
            }).then(response => {
                this.setState({
                    distributorName: response.data.facilityname
                })
            })
                .catch(err => {
                    console.log(err);
                })
        }

    }

    updateUser(e) {
        e.preventDefault();
        let {
            firstName,
            lastName,
            email,
            phone,
            org
        } = this.state.editUserData;
        axios.post(config.get('API_URL') + '/users/edit-user-profile/' + this.state.editUserData.id, {
            firstName,
            lastName,
            email,
            phone,
            org
        },{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(response => {
                console.log(response);
                if (response.data.status) {
                    this.handleNotificationClick("tr", 1, "Record has been successfully updated.");
                }
            })
            .catch(error => {
                console.log(error);
                this.handleNotificationClick("tr", 3, "Error")
            });
    }
    updatePassword(e){
        e.preventDefault();
        if (this.validator.allValid()) {
            const token = localStorage.usertoken;
            const decoded = jwt_decode(token);
            axios.post(config.get('API_URL') + '/users/edit-user-password/', {
                id: decoded._id,
                email: decoded.email,
                curr_pass: this.state.current_password,
                new_pass: this.state.new_password
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
                .then(response => {
                    //console.log(response);
                    if (response.data.status) {

                        this.handleNotificationClick("tr", 1, "Password has been successfully updated.");
                        this.setState({
                            current_password:'',
                            new_password:'',
                            re_type_password:''
                        });
                        this.validator.hideMessages();
                        this.forceUpdate();
                        setTimeout( function(){
                            window.location.href = "/";
                        }.bind(this)  , 2000 );
                    }
                    else {
                        this.handleNotificationClick("tr", 3, response.data.error);
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.handleNotificationClick("tr", 3, "Error")
                });
        }else {

            this.validator.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
        }
    }
    changePass(e){
        this.setState({ [e.target.name]: e.target.value })
    }
// info model functions STARt
toggleInfoUserModel(modal_type) {
    this.setState({
        newInfoModel: !this.state.newInfoModel,
        action_type: 'User Profile'
    })
}


    render() {
        this.validator.purgeFields();
        const confirmPasswordError = this.validator.message('re_type_password', this.state.re_type_password, `required|in:${this.state.new_password}`, {messages: {in: 'Passwords need to match!'}});

        return (
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                        {/*<Modal isOpen={this.state.newInfoModel} toggle={this.toggleInfoUserModel.bind(this)}>*/}
                        {/*      <ModalHeader toggle={this.toggleInfoUserModel.bind(this)}>{this.state.action_type}</ModalHeader>*/}
                        {/*      <ModalBody>*/}
                        {/*      <div className="row">*/}
                        {/*        <div className="col-lg-12 col-md-12 col-sm-12 col-sx-12">*/}
                        {/*            <div className="content">*/}
                        {/*                 <div className="row">*/}
                        {/*               */}
                        {/*                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">*/}
                        {/*                    <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12  p-5"*/}
                        {/*                    style={{*/}
                        {/*                        textAlign: "-webkit-center",*/}
                        {/*                        background: 'linear-gradient(134.72deg, #F5B00A 0%, #FE6009 100%)',*/}
                        {/*                        marginBottom: '10px',*/}
                        {/*                    }}*/}
                        {/*                    >*/}
                        {/*                    <img*/}
                        {/*                        src={imgNobody }*/}
                        {/*                        className="profile text-center"*/}
                        {/*                        style={{ height: "100px", borderRadius: "50%" }}*/}
                        {/*                    />*/}

                        {/*                    <div className="col-md-12 col-xs-12 col-sm-12 col-lg-12 p-5 text-center">*/}
                        {/*                        <p style={{ color: "#fff", fontSize: "120%" }}>*/}
                        {/*                        {this.state.editUserData.firstName + " "+ this.state.editUserData.lastName} */}
                        {/*                        */}
                        {/*                        </p>*/}
                        {/*                        <p style={{ color: "#fff" }}> {this.state.editUserData.organizationName} </p>*/}
                        {/*                    </div>*/}
                        {/*                    </div>*/}
                        {/*                    <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 ">*/}

                        {/*                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">*/}
                        {/*                        <div className="col-lg-3 col-md-3 col-xs-3 col-sm-3 p-0">*/}
                        {/*                        <p className="profile-head">Email</p>*/}
                        {/*                        </div>*/}
                        {/*                        <div className="col-lg-1 col-md-1 col-xs-1 col-sm-1 p-0">*/}
                        {/*                        <p className="profile-head">:</p>*/}
                        {/*                        </div>*/}
                        {/*                        <div className="col-lg-8 col-md-8 col-xs-8 col-sm-8 p-0">*/}
                        {/*                        <p>*/}
                        {/*                            {this.state.editUserData.email}*/}
                        {/*                           */}
                        {/*                        </p>*/}
                        {/*                        </div>*/}
                        {/*                    </div>*/}
                        {/*                    /!* <div className="col-lg-12 col-md-6 col-sm-12 col-xs-12 devider"></div> *!/*/}
                        {/*                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">*/}
                        {/*                        <div className=" col-lg-3 col-md-3 col-xs-2 col-sm-3  p-0">*/}
                        {/*                        <p className="profile-head">Mobile</p>*/}
                        {/*                        </div>*/}
                        {/*                        <div className="col-lg-1 col-md-1 col-xs-1 col-sm-1 p-0">*/}
                        {/*                        <p className="profile-head">:</p>*/}
                        {/*                        </div>*/}
                        {/*                        <div className=" col-lg-8 col-md-8 col-xs-8 col-sm-8  p-0">*/}
                        {/*                        <p style={{float:'left'}}>*/}
                        {/*                            +91 {this.state.editUserData.phone}*/}
                        {/*                        </p>{" "}*/}
                        {/*                        <span*/}
                        {/*                            style={{ color: "#14ce14", padding: "0px 10%" }}*/}
                        {/*                        >*/}
                        {/*                            verified*/}
                        {/*                        </span>*/}
                        {/*                        </div>*/}
                        {/*                    </div>*/}
                        {/*                 */}
                        {/*                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">*/}
                        {/*                        <div className="col-md-3 col-xs-3 col-sm-3 col-lg-3 p-0">*/}
                        {/*                        <p className="profile-head">Designation</p>*/}
                        {/*                        </div>*/}
                        {/*                        <div className="col-lg-1 col-md-1 col-xs-1 col-sm-1 p-0">*/}
                        {/*                        <p className="profile-head">:</p>*/}
                        {/*                        </div>*/}
                        {/*                        <>*/}
                        {/*                         {this.state.editUserData.designation==""?*/}
                        {/*                         <div className="col-md-8 col-xs-8 col-sm-8 col-lg-8 p-0">*/}
                        {/*                            { this.state.desigEditBox &&  <input id="designation" name="designation" value={this.state.editUserData.designation} />}*/}
                        {/*                            { !this.state.desigEditBox && <span class="glyphicon glyphicon-pencil" style={{marginLeft:'10px'}} aria-hidden="true" onClick={() =>{this.setState({desigEditBox:true})}}/> }*/}
                        {/*                                {this.state.desigEditBox && <>*/}
                        {/*                                    <span class="glyphicon glyphicon-remove-sign" style={{marginLeft:'10px',color:'red',cursor:'pointer'}} aria-hidden="true" onClick={() =>{this.setState({desigEditBox:!this.state.desigEditBox})}}/>*/}
                        {/*                                    <span class="glyphicon glyphicon-ok-sign" style={{marginLeft:'10px',color:'green',cursor:'pointer'}} aria-hidden="true" onClick={() =>{this.setState({desigEditBox:!this.state.desigEditBox})}}/>*/}
                        {/*                                 </>*/}
                        {/*                                 }*/}
                        {/*                          </div>*/}
                        {/*                          :*/}
                        {/*                        <div className="col-md-8 col-xs-8 col-sm-8 col-lg-8 p-0">*/}
                        {/*                        <p*/}
                        {/*                            style={{*/}
                        {/*                            float: "left",*/}
                        {/*                            textTransform: "capitalize",*/}
                        {/*                             wordBreak: 'break-word',*/}
                        {/*                            }}*/}
                        {/*                        >*/}
                        {/*                         {this.state.editUserData.designation}*/}
                        {/*                        </p>*/}
                        {/*                       </div>*/}
                        {/*                       }*/}
                        {/*                       </>*/}
                        {/*                    </div>*/}
                        {/*                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">*/}
                        {/*                        <div className="col-md-3 col-xs-5 col-sm-5 col-lg-3 p-0">*/}
                        {/*                        <p className="profile-head">Auth Type</p>*/}
                        {/*                        </div>*/}
                        {/*                        <div className="col-lg-1 col-md-1 col-xs-1 col-sm-1 p-0">*/}
                        {/*                        <p className="profile-head">:</p>*/}
                        {/*                        </div>*/}
                        {/*                        <>*/}
                        {/*                         { this.state.auth_type==""?*/}
                        {/*                         <div className="col-md-8 col-xs-8 col-sm-8 col-lg-8 p-0">*/}
                        {/*                           { this.state.authEditBox && <input id="auth type" name="auth type" value={this.state.auth_type} />}*/}
                        {/*                             { !this.state.authEditBox && <span class="glyphicon glyphicon-pencil" style={{marginLeft:'10px'}} aria-hidden="true" onClick={() =>{this.setState({authEditBox:true})}}/> }*/}
                        {/*                                 {this.state.authEditBox && <>*/}
                        {/*                                    <span class="glyphicon glyphicon-remove-sign" style={{marginLeft:'10px',color:'red',cursor:'pointer'}} aria-hidden="true" onClick={() =>{this.setState({authEditBox:!this.state.authEditBox})}}/>*/}
                        {/*                                    <span class="glyphicon glyphicon-ok-sign" style={{marginLeft:'10px',color:'green',cursor:'pointer'}} aria-hidden="true" onClick={() =>{this.setState({authEditBox:!this.state.authEditBox})}}/>*/}
                        {/*                                 </>*/}
                        {/*                                 }*/}
                        {/*                          </div>*/}
                        {/*                          :*/}
                        {/*                        <div className="col-md-8 col-xs-8 col-sm-8 col-lg-8 p-0">*/}
                        {/*                        <p*/}
                        {/*                            style={{*/}
                        {/*                            float: "left",*/}
                        {/*                            textTransform: "capitalize",*/}
                        {/*                             wordBreak: 'break-word',*/}
                        {/*                            }}*/}
                        {/*                        >*/}
                        {/*                            {this.state.auth_type}*/}
                        {/*                        </p>*/}
                        {/*                        </div>*/}
                        {/*                        }*/}
                        {/*                    </>*/}


                        {/*                    </div>*/}

                        {/*                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">*/}
                        {/*                        <div className="col-md-3 col-xs-5 col-sm-5 col-lg-3 p-0">*/}
                        {/*                        <p className="profile-head">Last Access</p>*/}
                        {/*                        </div>*/}
                        {/*                        <div className="col-lg-1 col-md-1 col-xs-1 col-sm-1 p-0">*/}
                        {/*                        <p className="profile-head">:</p>*/}
                        {/*                        </div>*/}
                        {/*                        <div className="col-md-8 col-xs-8 col-sm-8 col-lg-8 p-0">*/}
                        {/*                        <p*/}
                        {/*                            style={{*/}
                        {/*                            float: "left",*/}
                        {/*                            textTransform: "capitalize",*/}
                        {/*                            wordBreak: 'break-word',*/}
                        {/*                            }}*/}
                        {/*                        >*/}
                        {/*                            {moment(new Date(this.state.editUserData.last_logged_on)).format("DD-MM-YYYY HH:mm:ss")}*/}
                        {/*                        </p>*/}
                        {/*                        </div>*/}
                        {/*                    </div>*/}
                        {/*                        */}
                        {/*                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">*/}
                        {/*                        <div className="col-md-3 col-xs-5 col-sm-5 col-lg-3 p-0">*/}
                        {/*                        <p className="profile-head">Status</p>*/}
                        {/*                        </div>*/}
                        {/*                        <div className="col-lg-1 col-md-1 col-xs-1 col-sm-1 p-0">*/}
                        {/*                        <p className="profile-head">:</p>*/}
                        {/*                        </div>*/}
                        {/*                        <div className="col-md-8 col-xs-8 col-sm-8 col-lg-8 p-0">*/}
                        {/*                        <p*/}
                        {/*                            style={{*/}
                        {/*                            float: "left",*/}
                        {/*                            textTransform: "capitalize",*/}
                        {/*                            color: this.state.editUserData.is_active==="active"?"#14ce14":"red",*/}
                        {/*                            wordBreak: 'break-word',*/}
                        {/*                            }}*/}
                        {/*                        >*/}
                        {/*                            {this.state.editUserData.is_active}*/}
                        {/*                        </p>*/}
                        {/*                        </div>*/}
                        {/*                    </div>*/}
                        {/*                    </div>*/}
                        {/*                </div>*/}
                        {/*                </div>*/}
                        {/*               */}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*     </div>*/}
                        {/*      </ModalBody>*/}
                        {/*</Modal>*/}
                            <div className="card">
                                <div className="header">
                                    <h4 className="title" style={{display:'inline'}}>Edit Profile</h4>
                                    {/*<span class="glyphicon glyphicon-info-sign" aria-hidden="true" style={{cursor:'pointer',padding:'0px 5px'}} onClick={()=>{this.setState({newInfoModel: !this.state.newInfoModel})}}></span>*/}

                                    <p className="category"></p>
                                </div>
                                <div className="content">
                                    <form>
                                        <div className="">
                                            <div className="col-md-6"></div>
                                            <div className="col-md-6"></div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="control-label">First Name</label>
                                                    <input type="text" className="form-control" value={this.state.editUserData.firstName} onChange={(e)=>{ let {editUserData} = this.state; editUserData.firstName = e.target.value; this.setState({editUserData}); }} /></div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="control-label">Last Name</label>
                                                    <input type="text" className="form-control" value={this.state.editUserData.lastName} onChange={(e)=>{ let {editUserData} = this.state; editUserData.lastName = e.target.value; this.setState({editUserData}); }} /></div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="control-label">Email address</label>
                                                    <input placeholder="Email" type="email" className="form-control" disabled={true} value={this.state.editUserData.email} onChange={(e)=>{ let {editUserData} = this.state; editUserData.email = e.target.value; this.setState({editUserData}); }} /></div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="control-label">Phone</label>
                                                    <input type="text" className="form-control" disabled={true} value={this.state.editUserData.phone} onChange={(e)=>{ let {editUserData} = this.state; editUserData.phone = e.target.value; this.setState({editUserData}); }} /></div>
                                            </div>

                                            {/* For warehouse user only*/}
                                            <div style={{display: this.state.warehousedivDis}}>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="control-label">{this.state.distriUserType} Id</label>
                                                    <input placeholder="Email" type="email" className="form-control" disabled={true} value={this.state.distributorId} onChange={(e)=>{ let {editUserData} = this.state; editUserData.email = e.target.value; this.setState({editUserData}); }} /></div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="control-label">{this.state.distriUserType} Name</label>
                                                    <input type="text" className="form-control" disabled={true} value={this.state.distributorName} onChange={(e)=>{ let {editUserData} = this.state; editUserData.phone = e.target.value; this.setState({editUserData}); }} /></div>
                                            </div>
                                            </div>

                                            {/*<div className="col-md-6">*/}
                                            {/*    <div className="form-group">*/}
                                            {/*        <label className="control-label">Organization</label>*/}
                                            {/*        <input type="text" className="form-control" value={this.state.editUserData.org} onChange={(e)=>{ let {editUserData} = this.state; editUserData.org = e.target.value; this.setState({editUserData}); }} /></div>*/}
                                            {/*</div>*/}
                                            <div className="clearfix"></div>
                                        </div>
                                        <div className="col-md-12">
                                            <button type="submit" className="btn btn-primary" onClick={this.updateUser.bind(this)}>Update Profile</button>
                                        </div>
                                        <div className="clearfix"></div>
                                    </form>
                                    <hr/>
                                    {this.state.auth_type != 'Google' ?
                                        <div>
                                            <h4 className="title">Change Password</h4>
                                            <p className="category"></p>
                                            <form>

                                                <div className="col-md-6"></div>
                                                <div className="col-md-6"></div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        {/*<label className="control-label">Password</label>*/}
                                                        <input type="password" name="current_password"
                                                               className="form-control"
                                                               value={this.state.current_password}
                                                               onChange={this.changePass.bind(this)}
                                                               placeholder="Enter Current Password"/>
                                                        {this.validator.message('current_password', this.state.current_password, 'required')}
                                                    </div>
                                                    <div className="form-group">
                                                        <input type="password" name="new_password"
                                                               className="form-control" value={this.state.new_password}
                                                               onChange={this.changePass.bind(this)}
                                                               placeholder="Enter New Password"/>
                                                        {this.validator.message('new_password', this.state.new_password, 'required|min:6|max:20')}
                                                    </div>
                                                    <div className="form-group">
                                                        <input type="password" name="re_type_password"
                                                               className="form-control"
                                                               value={this.state.re_type_password}
                                                               onChange={this.changePass.bind(this)}
                                                               placeholder="Re-type Password"/>
                                                        {confirmPasswordError}
                                                    </div>
                                                </div>
                                                <div className="clearfix"></div>
                                                <div className="col-md-12">
                                                    <button type="submit" className="btn btn-primary"
                                                            onClick={this.updatePassword.bind(this)}>Change Password
                                                    </button>
                                                </div>
                                            </form>
                                            <br/><br/>
                                        </div> : null
                                    }

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
  }
}
const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(UserProfile);
